import { GridRegistrationStatusEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { StatusRuleSet } from '../status-availability.model';

/** Netzanmeldung: Status, die nicht jeder Mandant über einen Prozessschritt erreicht. */
export const GRID_REGISTRATION_STATUS_RULES: StatusRuleSet = {
  blacklist: {
    [GridRegistrationStatusEnum.CompletedPositioning]: (ctx) =>
      !!ctx.config.gridRegistration?.showCompletePositioning,
    [GridRegistrationStatusEnum.ConfiguringFeedInManagement]: (ctx) =>
      !ctx.config.gridRegistration?.skipConfiguringFeedInManagement,
    [GridRegistrationStatusEnum.ReadyToApprove]: null,
    [GridRegistrationStatusEnum.Error]: null,
    [GridRegistrationStatusEnum.PendingAssignTechnician]: null,
    [GridRegistrationStatusEnum.NeedMeterChange]: null
  }
};
